module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5hcdo"))).then(() => module.bundle.root('1iHdE'));